import { render, staticRenderFns } from "./PrescriptionDrugs.vue?vue&type=template&id=d0921e80&scoped=true"
import script from "./PrescriptionDrugs.vue?vue&type=script&lang=js"
export * from "./PrescriptionDrugs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0921e80",
  null
  
)

export default component.exports